/* Contains Kind and BonusType stuff */

export enum Kind {
  /** Apps/Programs allowed without options (OLD was NOT_CONFIGURED : 0) */
  AllowedBasic         = 0,
  /** Apps/Programs allowed with options (OLD was ALLOWED : 1) */
  AllowedOptions       = 1,
  /** Apps/Programs timelimited */
  Timelimited          = 2,
  /** Apps/Programs blocked */
  Blocked              = 3,
  /** Bonus programs (new as own kind) */
  Bonus                = 26,

  /** Internet blocked keyword */
  BlockedKw            = 6,
  /** Internet blocked domain */
  BlockedDomain        = 5,
  /** Internet allowed domain without options */
  AllowedDomainBasic   = 71,
  /** Internet allowed domain with options */
  AllowedDomainOptions = 7,
  /** Internet time limited domain */
  TimelimitedDomain    = 8,

  GroupWinapps         = 9,
  /** Bonus internet (new as own kind) */
  BonusInternet        = 25,
  /** Static Group Internet */
  GroupInternet        = 10,
  /** Static Group System */
  GroupSystem          = 4,

  /** Group 1 (Programs and Internet entries possible) */
  CustomGroup1         = 11,
  /** Group 2 (Programs and Internet entries possible) */
  CustomGroup2         = 12,
  /** Group 3 (Programs and Internet entries possible) */
  CustomGroup3         = 13,
  /** Group 4 (Programs and Internet entries possible) */
  CustomGroup4         = 14,
  /** Group 5 (Programs and Internet entries possible) */
  CustomGroup5         = 15,
}

export enum ReportKind {
  /** App in logs, not restricted */
  App                  = 4,
  /** Web Entry (url) in logs */
  WebLogs              = 15,
  WebRuntime           = 22,
}

/**
 * Bonus type (enum values (integers) do not represent the values sent to the API because they differ between CB and CC)
 */
export enum BonusType {
  NoBonus,
  AlwaysAllowed,
  AlwaysAllowedNoTimer,
  AlwaysAllowedWithBonus,
  AlwaysCountExe = 7,
  BlockExtension = -5
}

/**
 * Returns true if given kind is a group
 * @param kind Kind to check
 * @returns True if kind is a group
 */
export function kindIsGroup(kind: Kind): boolean {
  switch (kind) {
    case Kind.CustomGroup1:
    case Kind.CustomGroup2:
    case Kind.CustomGroup3:
    case Kind.CustomGroup4:
    case Kind.CustomGroup5:
    case Kind.GroupWinapps:
    case Kind.BonusInternet:
    case Kind.GroupInternet:
    case Kind.GroupSystem:
      return true;
    default:
      return false;
  }
}

/**
 * Returns true if given kind is a custom group
 * @param kind Kind to check
 * @returns True if kind is a custom group
 */
export function kindIsCustomGroup(kind: Kind): boolean {
  switch (kind) {
    case Kind.CustomGroup1:
    case Kind.CustomGroup2:
    case Kind.CustomGroup3:
    case Kind.CustomGroup4:
    case Kind.CustomGroup5:
      return true;
    default:
      return false;
  }
}

/**
 * Returns the language key for the given kind.
 * The language key can be used to get the translated name of the kind using NgxTranslate.
 */
export function getKindLangKey(kind: Kind) {
  return `KIND.${kind}`;
}

/**
 * Returns the color of the given kind (based on the base colors defined in CSS).
 * If no color was found for the given kind, an empty string is returned.
 */
export function kindToColor(kind: Kind): string {
  switch (kind) {
    case Kind.AllowedBasic:
    case Kind.AllowedDomainBasic:
      return 'green';
    case Kind.AllowedOptions:
    case Kind.AllowedDomainOptions:
      return 'green';
    case Kind.Timelimited:
    case Kind.TimelimitedDomain:
    case Kind.GroupInternet:
    case Kind.CustomGroup1:
    case Kind.CustomGroup2:
    case Kind.CustomGroup3:
    case Kind.CustomGroup4:
    case Kind.CustomGroup5:
      return 'yellow';
    case Kind.GroupSystem:
    case Kind.GroupWinapps:
      return 'midgrey';
    case Kind.Blocked:
    case Kind.BlockedDomain:
    case Kind.BlockedKw:
      return 'red';
    default:
      return '';
  }
}

/**
 * Returns the language key for the given bonus type.
 * The language key can be used to get the translated name of the bonus type using NgxTranslate.
 */
export function getBonusTypeLangKey(bonusType: BonusType): string {
  return `BONUS_TYPE.${BonusType[bonusType]}`;
}
